import { useState } from "react";
import { Box, TextField, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/SendRounded";

import { useTranslation } from "utils/locales/utilityFunctions";
import useNativeAppStyling from "hooks/useNativeAppStyling";
import { styles } from "../styles";

type AIChatFooterProps = {
  sendMessage: (text: string) => void;
  isLoading: boolean;
};

export function AIChatFooter({ sendMessage, isLoading }: AIChatFooterProps) {
  const { translate } = useTranslation();
  const { bottomOffset } = useNativeAppStyling();

  const [value, setValue] = useState<string>("");

  const hasValue = Boolean(value.trim());

  const handleSend = () => {
    if (!hasValue || isLoading) return;
    sendMessage(value.trim());
    setValue("");
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box sx={{ ...styles.footer, mb: bottomOffset }}>
      <Box sx={styles.inputShell}>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          placeholder={translate("ai-chat-input-placeholder")}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={styles.inputField}
        />

        <IconButton onClick={handleSend} disabled={!hasValue || isLoading} sx={styles.sendButton}>
          <SendIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
